const chooseEvent = select => {
  const $dropdown = select.querySelector('.select-dropdown');
  $dropdown.addEventListener('click', () => {
    sessionStorage.setItem('newsFiltered', 'true');
  });
};
const select = field => {
  field.addEventListener('click', e => {
    e.target.classList.toggle('_visible');
  });
  document.addEventListener('click', e => {
    if (!field.contains(e.target)) {
      field.classList.remove('_visible');
    }
  });
  chooseEvent(field);
};
const createWrap = translate => {
  const [$frame, $wrap, $clear] = ['div', 'div', 'button'].map(tag => document.createElement(tag));
  $frame.classList.add('frame', 'frame-layout-news-filter');
  $wrap.classList.add('news-filter', 'd-flex', 'container');
  $clear.classList.add('news-filter-clear', 'd-none');
  $clear.type = 'button';
  $clear.textContent = translate;
  return {
    $frame,
    $wrap,
    $clear
  };
};
const clearEvent = (clearBtn, rootHref) => {
  const isFiltered = sessionStorage.getItem('newsFiltered');
  if (isFiltered) clearBtn.classList.remove('d-none');
  clearBtn.addEventListener('click', () => {
    sessionStorage.removeItem('newsFiltered', 'true');
    window.location.href = rootHref;
  });
};
const filter = () => {
  const elementsList = [document.querySelector('.ce-news_categorylist'), document.querySelector('.ce-news_newsdatemenu')].filter(e => e);
  const fields = document.querySelectorAll('.news-filter-select');
  const el = document.querySelector('[data-filter-reset]');
  const rootHref = el ? el.href : '';
  const translate = el ? el.dataset.filterReset : '';
  const elements = createWrap(translate);
  if (elementsList.length) {
    elementsList[0].parentNode.insertBefore(elements.$frame, elementsList[0]);
    elements.$frame.appendChild(elements.$wrap);
    [...elementsList].forEach(element => elements.$wrap.appendChild(element));
    elements.$wrap.appendChild(elements.$clear);
  }
  if (fields) {
    fields.forEach(field => select(field));
    clearEvent(elements.$clear, rootHref);
  }
};
export default filter;